let header = {
    init() {

        setTimeout(function(){
            $('.header-page .col2').addClass('active');
        }, 500);

        var w = $(window).width();
        if (w < 700){
            if( $('.header-page .col2 img').length > 0){
                $('.header-page .col2').show();
            }else{
                $('.header-page .col2').hide();
            }
        }
    }
}

export default header;
